import { render, staticRenderFns } from "./YourOrderDetail.vue?vue&type=template&id=85155888&scoped=true&"
import script from "./YourOrderDetail.vue?vue&type=script&lang=js&"
export * from "./YourOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./YourOrderDetail.vue?vue&type=style&index=0&id=85155888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85155888",
  null
  
)

export default component.exports